import { QuotaDTO } from '@/modules/collections/lateQuotas/types/Quota.ts'
import { appConfig } from '@/config/app.ts'

export interface LateQuota {
  isLoading: boolean
  lateQuotas: QuotaDTO[]
  lateQuota: LateQuota | null
  editId: string | null
  filters: string
  isLoadingAction: boolean
}

export const initialState: LateQuota = {
  isLoading: false,
  lateQuotas: [],
  lateQuota: null,
  editId: null,
  filters: `?limit=${appConfig.pagination.defaultValue}`,
  isLoadingAction: false
}
